import React from 'react';
import { IntlProvider } from 'react-intl';
import * as Sentry from "@sentry/react";

// Hooks
import useI18n from "./hooks/useI18n";

// Translationfiles.dsaa
import '@formatjs/intl-pluralrules/locale-data/fi'; // locale data for fi
import '@formatjs/intl-pluralrules/locale-data/en'; // locale data for en
import '@formatjs/intl-pluralrules/locale-data/se'; // locale data for se
import '@formatjs/intl-pluralrules/locale-data/no'; // locale data for no

import locales_fi from './locales/fi.json';
import locales_en from './locales/en.json';
import locales_se from './locales/se.json';
import locales_no from './locales/no.json';
import MessageContextProvider from "./contexts/MessageContext";
import UserAccountContextProvider from "./contexts/UserAccountContext";
import App from "./App";
import { Amplify } from "aws-amplify";
import AuthContextProvider from "./contexts/AuthContext";

// translations
const messages = {
    fi: locales_fi,
    en: locales_en,
    se: locales_se,
    no: locales_no
};

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID
        }
    }
});

const Main = () => {
    const { setupLanguage, setupCountry } = useI18n();

    // Language is defined as a global variable, and it's exist in global context of application.
    // Every time the main component of the application is rendered it must be empty.
    const language = setupLanguage();
    setupCountry();

    // replace www-prefix with REACT_APP_URL for redirects to work correctly
    if (process.env.REACT_APP_REDIRECT_URL !== undefined && process.env.REACT_APP_REDIRECT_URL !== '') {
        window.location = window.location.href.replace(window.location.origin, process.env.REACT_APP_REDIRECT_URL);
        return null;
    }

    // replace www-prefix with REACT_APP_URL for redirects to work correctly
    if (window.location.hostname.startsWith("www") && typeof process.env.REACT_APP_URL !== 'undefined') {
        window.location = window.location.href.replace(window.location.origin, process.env.REACT_APP_URL);
    }

    return (
        <Sentry.ErrorBoundary fallback={"An error has occured"}>
            <IntlProvider locale={language} messages={messages[language]}>
                <AuthContextProvider>
                    <MessageContextProvider>
                        <UserAccountContextProvider>
                            <App />
                        </UserAccountContextProvider>
                    </MessageContextProvider>
                </AuthContextProvider>
            </IntlProvider>
        </Sentry.ErrorBoundary>
    );
};

export default Main;
